import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollTopButton from "@/components/feature/ScrollTopButton";

const faqs = [
  {
    q: "天天漫画网多久更新一次漫画？",
    a: "网站每日更新，热门连载漫画的最新话会在每日上午陆续同步上线，最晚当天晚间更新完毕。进入首页『今日更新』板块即可查看当天所有新增章节。",
  },
  {
    q: "如何快速找到想看的漫画？",
    a: "你可以在顶部搜索框直接输入漫画名称，也可以进入『漫库』页面，按分类（热血冒险、奇幻仙侠、都市生活等）筛选，或按热度、评分排序浏览。",
  },
  {
    q: "连载中的漫画会不会突然断更？",
    a: "我们会对连载作品持续跟进，若某部作品进入休刊或停更，会在作品详情页标注当前状态，方便你及时了解追更进度，避免长时间等待。",
  },
  {
    q: "漫画内容适合所有年龄段的读者吗？",
    a: "天天漫画网收录了覆盖多种题材的连载作品，从校园青春到悬疑推理应有尽有。建议家长和读者根据作品详情页的题材与标签，选择适合自己阅读的内容。",
  },
  {
    q: "为什么我看不到某部作品的章节列表？",
    a: "若作品当前处于休刊或平台整理阶段，章节列表可能暂时为空。你可以先浏览同分类的其他连载漫画，我们会尽快同步恢复该作品的更新信息。",
  },
  {
    q: "追更收藏有什么作用？",
    a: "点击『追更收藏』后，系统会记录你关注的连载漫画。当该作品更新最新话时，你可以在更新列表第一时间看到提醒，追更漫画不迷路。",
  },
];

const faqLdJson = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

const faqPageLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  name: "天天漫画网 - 常见问题",
  url: "https://panelplay1.github.io/faq",
  inLanguage: "zh-CN",
};

export default function FaqPage() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqPageLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqLdJson) }} />
      <Navbar />
      <main className="mx-auto max-w-3xl px-4 py-10 md:px-6">
        <nav className="mb-6 flex items-center gap-2 text-xs text-foreground-500" aria-label="面包屑">
          <Link to="/" className="hover:text-primary-600">首页</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-900">常见问题</span>
        </nav>

        <h1 className="font-heading text-2xl text-foreground-950 md:text-3xl">常见问题</h1>
        <p className="mt-2 text-sm text-foreground-600">
          关于天天漫画网的更新、检索、追更等常见疑问，这里都有答案。
        </p>

        <div className="mt-8 space-y-3">
          {faqs.map((f) => (
            <details
              key={f.q}
              className="group rounded-lg border border-background-200 bg-background-50 p-5 open:border-primary-300"
            >
              <summary className="flex cursor-pointer list-none items-center justify-between gap-3 text-sm font-bold text-foreground-900">
                {f.q}
                <i className="ri-add-line text-lg text-primary-500 transition-transform group-open:rotate-45"></i>
              </summary>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{f.a}</p>
            </details>
          ))}
        </div>

        <div className="mt-10 rounded-lg border border-background-200 bg-background-100 p-6 text-center">
          <h2 className="font-heading text-lg text-foreground-950">还有别的问题？</h2>
          <p className="mt-2 text-sm text-foreground-600">没找到答案，欢迎联系我们。</p>
          <a
            href="mailto:service@tiantian-mh.example.com"
            className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-mail-line"></i>联系我们
          </a>
        </div>
      </main>
      <Footer />
      <ScrollTopButton />
    </>
  );
}